import { useState } from "react";
import { Link } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Footer() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubscribeStatus("");

    try {
      const response = await fetch(`${API}/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (response.ok) {
        setSubscribeStatus("success");
        setEmail("");
      } else {
        setSubscribeStatus("error");
      }
    } catch (error) {
      setSubscribeStatus("error");
    }

    setIsSubmitting(false);
  };

  return (
    <>
      {/* Subscription Banner */}
      <div className="bg-[#FFE102] py-12 px-4" data-testid="subscription-banner">
        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-black mb-2">Stay Connected</h3>
          <p className="text-black mb-6">Subscribe to receive updates on new products, events, and ways to support our youth programs.</p>
          
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="flex-1 px-4 py-3 rounded-lg border-2 border-black text-black placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-black"
              required
              data-testid="subscribe-email-input"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-8 py-3 bg-black text-white font-bold rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50"
              data-testid="subscribe-button"
            >
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </button>
          </form>

          {subscribeStatus === "success" && (
            <p className="mt-4 text-black font-semibold">Thank you for subscribing!</p>
          )}
          {subscribeStatus === "error" && (
            <p className="mt-4 text-red-700 font-semibold">Something went wrong. Please try again.</p>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#17181B] text-white py-12 px-4" data-testid="footer">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="/images/new_logo.png" 
                alt="Calvin D. Butts Inc. Logo" 
                className="h-24 w-auto mb-4"
              />
              <p className="text-white/70 text-sm">Empowering Metro Atlanta youth through education, mental health support, and community engagement.</p>
            </div>
            <div>
              <h3 className="font-bold mb-4 text-[#FFE102]">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-white/70 hover:text-white">Home</Link></li>
                <li><Link to="/programs" className="text-white/70 hover:text-white">Programs</Link></li>
                <li><Link to="/gallery" className="text-white/70 hover:text-white">Gallery</Link></li>
                <li><Link to="/partners" className="text-white/70 hover:text-white">Partners</Link></li>
                <li><Link to="/shop" className="text-white/70 hover:text-white">Shop</Link></li>
                <li><Link to="/donate" className="text-white/70 hover:text-white">Donate</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold mb-4 text-[#FFE102]">Programs</h3>
              <ul className="space-y-2 text-sm text-white/70">
                <li>STEAM Education</li>
                <li>THOROpy</li>
                <li>Bridge Program</li>
                <li>Mental Health Services</li>
              </ul>
            </div>
            <div>
              <h3 className="font-bold mb-4 text-[#FFE102]">Connect</h3>
              <ul className="space-y-2 text-sm text-white/70">
                <li><a href="mailto:info@calvinbuttsms.org" className="hover:text-white">info@calvinbuttsms.org</a></li>
                <li><a href="tel:478-227-5849" className="hover:text-white">478-227-5849</a></li>
                <li>Metro Atlanta, GA</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/20 pt-8 text-center text-sm text-white/60">
            <p>&copy; 2025 Calvin D. Butts Inc. All rights reserved. 501(c)(3) Nonprofit Organization.</p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;